module.exports = __webpack_public_path__ + "fonts/icomoon.1473179.ttf";